import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import imgProfile from '../../images/profile.jpg'
import imgApply from '../../images/pen.jpg'
import imgApplications from '../../images/paper.jpg'
import Option from './Option';

export default class Dashboard extends Component {
    constructor(props) {
        super(props)

        this.state = {};
    }

    componentDidMount() {
        fetch('api/login?token=' + sessionStorage.getItem("token"), {
            method: 'GET'
        })
            .then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        if (!data.googleId) {
                            alert('Google sign in could not complete authentication.  Please sign in to authenticate.');
                            this.props.history.push('/signin');
                        } else {
                            this.setState({ googleId: data.googleId, name: data.name })
                            this.props.history.push('/dashboard/' + data.googleId)
                        }
                    })
                } else {
                    alert('There was an error in the sign in process.  Please try again at a later time.');
                }
            })
    }

    editProfile = () => {
        this.props.history.push('/profile/' + this.state.googleId);
    }

    newApplication = () => {       
        this.props.history.push('/application/' + this.state.googleId);
    }

    viewApplications = () => {
        this.props.history.push('/applicationlist/' + this.state.googleId);
    }

    render() {
        return (
            <div>
                <Container className="form-border">
                    <Row>
                        <Col sm="12">
                            <div
                                className="rounded px-3 px-sm-4 my-3 py-3 py-sm-5"
                                style={{ backgroundColor: "#e9ecef" }}
                            >
                                <h1 className='display-4'>St. Louis County Boards and Commissions</h1>
                                <hr />
                                <p className='lead'>
                                    <strong>{this.state.name}</strong>, welcome to your St. Louis County Boards and Commissions dashboard.
                                </p>
                                <p className='lead mb-0'>
                                    Please select an option below.
                                </p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="4">                        
                            <Option onClick={this.editProfile} cardTitle="Profile" cardBody="Edit your Profile" picture={imgProfile} />
                        </Col>
                        <Col md="12" lg="4">
                            <Option onClick={this.newApplication} cardTitle="Apply" cardBody="Apply for a Board or Commission" picture={imgApply} />
                        </Col>
                        <Col md="12" lg="4">
                            <Option onClick={this.viewApplications} cardTitle="View Applications" cardBody="View status of your existing applications" picture={imgApplications} />
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}